export const VB_TOKENS = {
  void0: "#05070D", void1: "#0A0E1A", void2: "#131823",
  fog: "rgba(40,55,85,0.18)",
  steel0: "#1A2030", steel1: "#2A3142", steel2: "#3D475C",
  steel3: "#4A5568", steel4: "#6B7894", steel5: "#9AA8C2",
  gold0: "#5A3F18", gold1: "#8A6426", gold2: "#B6863A",
  gold3: "#D4A24C", gold4: "#F5C56D", gold5: "#FFD98A",
  goldHot: "#FFF1C9",
  cyan0: "#003A4D", cyan1: "#007089", cyan2: "#00B7D9",
  cyan3: "#00E5FF", cyan4: "#7FF0FF", cyan5: "#D6FAFF",
  red0: "#5A0F15", red1: "#A52229", red2: "#FF3B47", red3: "#FF6B72", red4: "#FFB3B7",
  green0: "#013B27", green1: "#017A4D", green2: "#00D97E", green3: "#7BF0B5",
  text0: "#FFFFFF", text1: "#E5E9F2", text2: "#9AA8C2", text3: "#5C6478", text4: "#3A4258",
} as const;

export const VB_FONTS = {
  display: '"Bebas Neue", "Druk Wide", "Anton", Impact, sans-serif',
  ui: '"Inter", -apple-system, sans-serif',
  mono: '"JetBrains Mono", "Menlo", monospace',
} as const;

export type VBTokens = typeof VB_TOKENS;
